export * from './IconHeatPump';
export { default as IconHeatPump } from './IconHeatPump';
